module.exports = __webpack_public_path__ + "static/ff-clan-std-bold-350927bf058a972e9701d882d0c2b4e8.woff";